export const useIsInIFrame = () => {
  return window.self !== window.top
}
